import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import useAgencyProviderPackage from '@hooks/useAgencyProviderPackage'
import { generateUrls } from '@hooks/useAgency'

import type { AgencyProviderPackageModel } from '@models/types'
import type { ListItemProps } from '@hooks/useSelectEntities'

interface AgencyProviderPackageListItemProps extends ListItemProps {
  agencyProviderPackage: AgencyProviderPackageModel,
}

const AgencyProviderPackageListItem = (props: AgencyProviderPackageListItemProps) => {
  const {
    agencyProviderPackage: initAgencyProviderPackage,
    ...restProps
  } = props

  const agencyProviderPackagePayload = useAgencyProviderPackage(initAgencyProviderPackage)

  const {
    agency,
    // @ts-expect-error TS2339
    agency: { id: agencyId, title: agencyTitle },
  } = agencyProviderPackagePayload

  const { editAgencyUrl } = generateUrls(agency)

  return (
    <DashboardModuleListItem
      showCheckbox
      title={agencyTitle}
      {...restProps}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        # {agencyId}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editAgencyUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AgencyProviderPackageListItem
